var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecuirtyGardIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 24,
    viewBox: "0 0 21 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.07031 22.698V20.9734C1.07031 17.481 3.8719 14.65 7.32784 14.65H13.0165C16.4725 14.65 19.274 17.481 19.274 20.9734V22.698M5.62124 22.698V19.8237M14.7231 22.698V19.632M6.1901 6.0272C8.48149 8.01195 11.8628 8.01195 14.1542 6.0272M14.7231 6.60205V4.21934L16.3907 1.75264C16.6487 1.37109 16.3783 0.853516 15.921 0.853516H4.42334C3.96607 0.853516 3.69568 1.37109 3.95363 1.75264L5.62124 4.21934V6.60205M14.7231 7.75176C14.7231 10.2916 12.6855 12.3506 10.1722 12.3506C7.65876 12.3506 5.62124 10.2916 5.62124 7.75176V4.87749H14.7231V7.75176Z",
    stroke: "#8C8686",
    strokeWidth: 1.57765,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecuirtyGardIcon);
export default __webpack_public_path__ + "static/media/Secuirty_Gard_icon.68cdebbb29372788444aec043ebed620.svg";
export { ForwardRef as ReactComponent };